function splitArrayInChunks (array, chunkSize) {
  var result = []

  if (chunkSize && Array.isArray(array)) {
    while (array.length) {
      result.push(array.splice(0, chunkSize))
    }
  } else {
    result = array
  }

  return result
}

export default {
  splitArrayInChunks: splitArrayInChunks
}



// WEBPACK FOOTER //
// ./src/library/core/collections.js